import React from "react";
import Icon from "assets/icons";
import Variant from "shared/enums/Variant";
import Button from "shared/components/button";
import { useCopies } from "shared/hooks/useCopies";
import { OfflinePaymentRequestedPropTypes } from "./types";
import { useOfflinePaymentRequestedService } from "./service";

export default function OfflinePaymentRequested(props: OfflinePaymentRequestedPropTypes) {
  const copies = useCopies();
  const service = useOfflinePaymentRequestedService(props);

  return (
    <React.Fragment>
      {!props.state.canShowPaymentModes && (
        <div className="paymentWrapper_updateRequest isOfflinePaymentRequested">
          <div className="paymentWrapper_updateRequest--requestedTo">
            <p className="paymentWrapper_updateRequest--requestedToMsg">
              <Icon.InfoCircleThick />
              <span className="paymentWrapper_updateRequest--requestedToMsgText">
                {copies.get("offline.payment.already.requested")}
              </span>{" "}
              {copies.get("offline.payment.request.update.msg")}
            </p>
            <span className="paymentWrapper_updateRequest--requestedToAction">
              <Button.Link label={copies.get("click.here")} onClick={service.updateOfflinePaymentRequestClickHandler} />
            </span>
          </div>

          <div className="isOfflinePaymentRequested_actions">
            <Button
              label={copies.get("offline.payment.cancel.request.label")}
              onClick={service.cancelRequestClickHandler}
              variant={Variant.ERROR}
            />

            <Button
              label={copies.get("offline.payment.already.requested.pay.self")}
              onClick={service.showPaymentModesClickHandler}
              isOutline
            />
          </div>
        </div>
      )}
    </React.Fragment>
  );
}
